import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { StringJoinExpression } from "../../../Models/Strings/StringJoinExpression";

export class StringJoinExpressionEvaluator implements IExpressionEvaluator<StringJoinExpression> {
  get type(): string {
    return "StringJoin";
  }

  private joinValue(value: any, separator: string): string {
    if (Array.isArray(value)) {
      const array = value.map((item) => String(item));
      return array.join(separator);
    } else {
      return String(value);
    }
  }

  evaluate(expression: StringJoinExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const value = context.Evaluator.evaluate(expression.Value, context);
    const separator = expression.Separator;

    if (value instanceof Promise) {
      return value.then((resolvedValue) => this.joinValue(resolvedValue, separator));
    }

    return this.joinValue(value, separator);
  }
}
